import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout, { Content, Footer, Header } from 'antd/es/layout/layout';

import HeaderComponent from './components/Header';
import FooterComponent from './components/Footer';
import { styles } from './styles';
import { HOME_PATH } from './utils/constant';

// ✅ Lazy-loaded pages only
const Home = lazy(() => import('./views/Home'));
const Fixture = lazy(() => import('./views/Fixture'));
const CurrentVersion = lazy(() => import('./views/Landing/currentVersion'));
const Landing = lazy(() => import('./views/Landing'));
const Standings = lazy(() => import('./views/Standings'));
const FixtureList = lazy(() => import('./views/FixtureList'));
const AddStreamComponent = lazy(() => import('./components/addStream'));
const UpdateStreamComponent = lazy(() => import('./components/UpdateStream'));
const ContactUsComponent = lazy(() => import('./components/ContactUs'));
const PrivacyPolicy = lazy(() => import('./components/PrivacyPolicy'));
const AboutUs = lazy(() => import('./components/AboutUs'));

const footerStyle: React.CSSProperties = {
  textAlign: 'center',
  color: '#fff',
  backgroundColor: '#95100d',
};

const Router = () => {
  return (
    <Layout>
      {/* ✅ Header and Footer are eagerly loaded */}
      <Header style={styles.header}>
        <HeaderComponent />
      </Header>

      <Content style={{ background: '#222121', textAlign: 'center', minHeight: '100vh' }}>
        {/* ✅ Lazy-load only page-level components */}
        <Suspense fallback={<div style={{ color: '#000', padding: '2rem' }}>Loading...</div>}>
          <Routes>
            <Route path="/streams/Soccer" element={<Navigate to="/live/Soccer" replace />} />
            <Route path="/live/:soccer" element={<Home />} />
            <Route path="/streams/:categoryName" element={<Home />} />
            <Route path="/" element={<Navigate to={HOME_PATH} replace />} />
            <Route path="/v2" element={<Navigate to={HOME_PATH} replace />} />
            <Route path={HOME_PATH} element={<CurrentVersion />} />
            <Route path="/landing" element={<Landing />} />
            <Route path="/home" element={<Navigate to="/landing" replace />} />
            <Route path="/fixture/:teams" element={<Fixture />} />
            <Route path="/fixture/:teams/add" element={<AddStreamComponent />} />
            <Route path="/fixture/:teams/update" element={<UpdateStreamComponent />} />
            <Route path="/leagues/standings" element={<Standings />} />
            <Route path="/leagues/:leagueName/:id" element={<FixtureList />} />
            <Route path="/teams/:teamName/:id" element={<FixtureList />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact" element={<ContactUsComponent />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="*" element={<Navigate to={HOME_PATH} />} />
          </Routes>
        </Suspense>
      </Content>

      <Footer style={footerStyle}>
        <FooterComponent />
      </Footer>
    </Layout>
  );
};

export default Router;
